
import "./Membership.scss";

export default function Membership() {
  
  
  return (
    <div className="login">
      <div className="top">
        <div className="wrapper">
          <img
            className="logo"
            src="https://i.ibb.co/KryJLS1/logoyotta.png"
            alt=""
          />
        </div>
      </div>
      <div className="container">
        <form>
          <h1>No cuenta con una membresía activa</h1>
          <span>
            Comuniquese con soporte soporte@yottalan.com
          </span>
         
        </form>
        
      </div>
    </div>
  );
}